// extracted by mini-css-extract-plugin
export default {"container":"conceptSummaryTooltip_container__ehZqe","header":"conceptSummaryTooltip_header__mRuud","text":"conceptSummaryTooltip_text__uDD74"};